var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-invoice',{attrs:{"action-hooks":"updateInvoice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }